// fragrance button rotate on scroll

window.addEventListener('scroll', function () {
  const scrollCircle = document.getElementById('scrollCircle');

  // Check if the scrollCircle element exists
  if (scrollCircle) {
    const rotatingElement = scrollCircle.querySelector('.rotating-element');

    const scrollPosition = window.pageYOffset;
    const rotationValue = scrollPosition * 0.2; // Adjust the rotation speed as desired

    rotatingElement.style.transform = `rotate(${rotationValue}deg)`;
  }
});

// FAQS Toggle

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.faq-toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      const answer = this.nextElementSibling;
      const iconText = this.querySelector('.toggle-icon'); // The "+" icon
      const iconSVG = this.querySelector('.toggle-icon-svg'); // The SVG icon

      // Check if the toggle is currently open
      if (answer.style.maxHeight) {
        // Begin to close it
        answer.style.maxHeight = null;
        setTimeout(() => {
          answer.style.display = 'none';
          iconText.style.display = 'block'; // Show the "+" icon
          iconSVG.style.display = 'none'; // Hide the "-" SVG icon
        }, 300); // Match this delay with your CSS transition duration
      } else {
        // Open it
        answer.style.display = 'block';
        // Need to wait a frame for the display change to take effect
        window.requestAnimationFrame(() => {
          answer.style.maxHeight = answer.scrollHeight + 'px';
          iconText.style.display = 'none'; // Hide the "+" icon
          iconSVG.style.display = 'block'; // Show the "-" SVG icon
        });
      }
    });
  });
});

// Search Bar: update placeholder text
const searchInput = (document.querySelector('.sf-search-form span').textContent = 'Search');
searchInput.placeholder = 'Search';

// open all external links in a new tab
(function () {
  var links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
})();
